import { Instagram, Facebook, Youtube, Music2 } from "lucide-react";
import { SOCIALS } from "@/lib/constants";

const ICONS = { Instagram, Facebook, YouTube: Youtube, TikTok: Music2 };
const COLORS = { Instagram: "bg-rose-500", Facebook: "bg-cyan-500", TikTok: "bg-black text-white", YouTube: "bg-rose-500" };

export const SocialLinks = ({ compact = false }) => (
  <div className={`flex flex-wrap gap-2 ${compact ? "" : "sm:gap-3"}`} data-testid={compact ? "footer-socials" : "social-links"}>
    {SOCIALS.map((s) => {
      const Icon = ICONS[s.name];
      return (
        <a key={s.name} href={s.url} target="_blank" rel="noreferrer" aria-label={s.name} data-testid={`social-${s.name.toLowerCase()}${compact ? "-footer" : ""}`}
          className={compact ? "flex h-9 w-9 items-center justify-center rounded-full border-2 border-black bg-white transition-transform hover:-translate-y-0.5" : "sticker-btn flex items-center gap-2 rounded-full bg-white px-4 py-2.5 text-sm"}>
          <span className={`flex h-6 w-6 items-center justify-center rounded-full ${compact ? "" : COLORS[s.name]}`}><Icon className="h-4 w-4" /></span>
          {!compact && <span>{s.name} <span className="text-stone-500">{s.handle}</span></span>}
        </a>
      );
    })}
  </div>
);

export const FollowSection = () => (
  <section className="mx-auto mt-14 max-w-[1440px] px-4 sm:px-6 md:mt-24 lg:px-12" data-testid="follow-section">
    <div className="rounded-3xl border-2 border-black bg-[#F6E7CB] p-6 shadow-[6px_6px_0_#000] md:p-10">
      <p className="font-display text-sm uppercase tracking-[0.2em] text-amber-700">Community</p>
      <h2 className="mt-2 font-display text-2xl sm:text-4xl">Seguici sui social</h2>
      <p className="mt-2 max-w-xl text-stone-700">Aperture di buste, nuovi arrivi, risultati dei tornei e promo esclusive per chi ci segue.</p>
      <div className="mt-6"><SocialLinks /></div>
    </div>
  </section>
);
